import createReducer from '../utils/createReducer';
import { API_CALL_FAILURE, API_CALL_REQUEST, API_CALL_SUCCESS } from '../constants/actionTypes';
import { CONTACT } from '../constants/apiTypes';

const initialState = {
  errors: [],
  isSubmitting: false
};

const contactReducer = createReducer(initialState, {
  [API_CALL_REQUEST]: (state, action) =>
    action.api === CONTACT
      ? {
          errors: [],
          isSubmitting: true
        }
      : undefined,
  [API_CALL_SUCCESS]: (state, action) =>
    action.api === CONTACT
      ? {
          isSubmitting: false
        }
      : undefined,
  [API_CALL_FAILURE]: (state, action) =>
    action.api === CONTACT
      ? {
          errors: action.errors.messages,
          isSubmitting: false
        }
      : undefined
});

export default contactReducer;
